import { useLanguage } from '../utils/LanguageContext';
import translations from '../components/ComponentsTranslations.lang.json';
import { useAuth } from '../utils/AuthContext';
import { useEffect } from 'react';
import { OneTimeActionButton } from './common/CommonComponents';

const VerifyEmailForm = () => {
  const { lang } = useLanguage(translations);
  const { userEmail, userEmailIsVerified, sendEmailVerification, handleNavigation } = useAuth();

  useEffect(() => {
    const checkIfEmailIsVerified = async () => {
      if (await userEmailIsVerified()) {
        stopChecking();
        await handleNavigation();
      }
    };

    const stopChecking = () => {
      clearInterval(interval);
      window.removeEventListener('focus', checkIfEmailIsVerified);
    };

    const interval = setInterval(checkIfEmailIsVerified, 1000); //check every second
    window.addEventListener('focus', checkIfEmailIsVerified); //check if the tab becomes focused

    return stopChecking; //for unmounting component
  }, [userEmailIsVerified, handleNavigation]);

  return (
    <>
      <h1>{lang('verifyEmailTitle')}</h1>
      <p>{lang('verifyEmailSentMessage')}</p>
      <p>
        <b>{userEmail()}</b>
      </p>
      <p>{lang('verifyEmailFurtherInstructions')}</p>
      <OneTimeActionButton onClick={sendEmailVerification} confirmation={lang('verifyEmailSentMessage')}>
        {lang('resendEmailVerification')}
      </OneTimeActionButton>
    </>
  );
};

export default VerifyEmailForm;
